import React, { FC } from 'react';
import { TaskId } from 'api/models';
import { FieldSectionMapping } from 'components/organisms/field-sections/section-list';
import { DefaultTaskFields } from 'components/organisms/task-pane/task-detail/task-fields/default-task-fields';
import { TaskCustomFields } from 'components/organisms/task-pane/task-detail/task-fields/task-custom-fields';
import { useSelectedPriority } from 'data/fields/hooks';
import { Task } from 'data/tasks';

interface Props {
  data: Task;
  fieldSectionMapping: FieldSectionMapping[];
}

export const TaskFields: FC<Props> = ({ data, fieldSectionMapping }) => {
  const { project: projectId, taskId } = data;
  const taskFieldsValues = data.fields || [];
  const selectedPriority = useSelectedPriority(taskFieldsValues);

  return (
    <>
      <DefaultTaskFields
        taskId={TaskId(projectId, taskId)}
        effort={data.effort}
        progress={data.progress}
        priority={selectedPriority}
        createdBy={data.createdBy}
        createdAt={data.createdAt}
        completedAt={data.completedAt}
        startDateActual={data.startDateActual}
      />

      <TaskCustomFields
        values={data.fields}
        fieldSectionMapping={fieldSectionMapping}
        taskId={TaskId(projectId, taskId)}
      />
    </>
  );
};
